// extracted by mini-css-extract-plugin
export default {"root":"root--Y5zk4","bookingAssistance":"bookingAssistance--PXxZc","bookingAssistanceTitle":"bookingAssistanceTitle--SJRmi"};